import { colors } from '@/styles/GlobalStyle';
import styled from 'styled-components';

export const Container = styled.section`
  width: 100%;
  max-width: 1360px;

  margin-top: 45px;

  .swiper-container {
    width: 100%;
    height: 100%;
    padding: 4px 0 14px 0;
  }

  .swiper-slide {
    text-align: center;
    background: transparent;

    width: 210px;
    height: auto;

    /* Center slide text vertically */
    display: flex;
    justify-content: center;
    align-items: center;

    @media (min-width: 1024px) {
      width: auto;
    }
  }

  @media (max-width: 1440px) {
    padding: 0 40px;
  }

  @media (max-width: 850px) {
    margin-top: 24px;
  }

  @media (max-width: 499px) {
    padding: 0 16px;
  }
`;

export const Servico = styled.a`
  width: 100%;
  max-width: 220px;
  height: 80px;

  background: ${colors.orange400};
  border-radius: 12px;

  transition: background 0.3s;

  &:hover {
    background: ${colors.orange500};
  }

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 10px;

  color: white;
  font-size: 15px;
  line-height: 20px;
  font-family: 'Sora';
  font-weight: 400;
  white-space: nowrap;

  box-shadow: 0px 3px 10px rgba(255, 70, 0, 0.36);

  @media (max-width: 1280px) and (min-width: 1024px) {
    font-size: 13px;
    gap: 6px;
    padding: 0 6px;
  }
`;
